import React from 'react';

function SpinnerInline() {
    return (
        <div className="loader loader"><div></div><div></div><div></div><div></div></div>
    );
}

export default SpinnerInline